import { EthSafeTransaction } from '@safe-global/protocol-kit'
import { encodeFunctionData, type Abi } from 'viem'
import {
  SAFE_OPERATION_CALL,
  SAFE_TRANSACTION_VALUE_DEFAULT,
  SAFE_TRANSACTION_DATA_DEFAULT,
  SAFE_TX_GAS_DEFAULT,
} from '@/constants/main'

export interface SafeTransactionParams {
  to: string
  value?: string
  data: string
  operation?: number
}

export function buildSafeTransactionParams(params: SafeTransactionParams): {
  to: string
  value: string
  data: string
  operation: number
} {
  return {
    to: params.to,
    value: params.value || SAFE_TRANSACTION_VALUE_DEFAULT,
    data: params.data || SAFE_TRANSACTION_DATA_DEFAULT,
    operation: params.operation ?? SAFE_OPERATION_CALL,
  }
}

export function encodeContractCall(
  abi: Abi,
  functionName: string,
  args: unknown[]
): string {
  return encodeFunctionData({
    abi,
    functionName,
    args,
  })
}

export function ensureSafeTransactionGas(
  safeTx: EthSafeTransaction,
  defaultGas: string = SAFE_TX_GAS_DEFAULT
): void {
  const currentGas = safeTx.data.safeTxGas
  if (!currentGas || currentGas === '0' || BigInt(currentGas) < 100000n) {
    safeTx.data.safeTxGas = defaultGas
  }
}
